/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverBlockAdminDto } from '../models/DriverBlockAdminDto';
import type { Pagination1OfDriverBlockAdminDto } from '../models/Pagination1OfDriverBlockAdminDto';
import type { PostDriverBlockRequestAdmin } from '../models/PostDriverBlockRequestAdmin';
import type { PutDriverBlockRequestAdmin } from '../models/PutDriverBlockRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverBlocksService {
    /**
     * **Required Policy:** `ManageDriverBlocks`
     * @returns DriverBlockAdminDto Created
     * @throws ApiError
     */
    public static postDriverBlockAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverBlockRequestAdmin,
    }): CancelablePromise<DriverBlockAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverblocks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverBlocks`
     * @returns Pagination1OfDriverBlockAdminDto OK
     * @throws ApiError
     */
    public static getDriverBlocksAdmin({
        driverId,
        blockedByUserId,
        fromBlockedAt,
        toBlockedAt,
        fromUnblockedAt,
        toUnblockedAt,
        createdAtFrom,
        createdAtTo,
        regionId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        driverId?: number,
        blockedByUserId?: string,
        fromBlockedAt?: string,
        toBlockedAt?: string,
        fromUnblockedAt?: string,
        toUnblockedAt?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        regionId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfDriverBlockAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverblocks',
            query: {
                'driverId': driverId,
                'blockedByUserId': blockedByUserId,
                'fromBlockedAt': fromBlockedAt,
                'toBlockedAt': toBlockedAt,
                'fromUnblockedAt': fromUnblockedAt,
                'toUnblockedAt': toUnblockedAt,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'regionId': regionId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverBlocks`
     * @returns DriverBlockAdminDto OK
     * @throws ApiError
     */
    public static getDriverBlockAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverBlockAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverblocks/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverBlocks`
     * @returns DriverBlockAdminDto OK
     * @throws ApiError
     */
    public static putDriverBlockAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutDriverBlockRequestAdmin,
    }): CancelablePromise<DriverBlockAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driverblocks/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverBlocks`
     * @returns DriverBlockAdminDto OK
     * @throws ApiError
     */
    public static getActiveDriverBlockAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<DriverBlockAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverblocks/driver/{driverId}/active',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
